<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-checkbox
                :label="$t('selectAllRegions')"
                @change="selectAll"
                v-model="selectAllItems"
                v-if="withTotalSelect"
                color="orange lighten-2"
                class="font-weight-bold black--text"
        ></v-checkbox>
        <v-autocomplete
                multiple
                v-model="searchModels"
                :items="itemsList"
                :chips="hasChips"
                hide-no-data
                item-text="name"
                item-value="value"
                :label="componentLabel"
                @change="valueChange"
                return-object
                color="orange lighten-2"
                item-color="orange lighten-2"
                :rules="rules"
                required
                @input="regionsMultiple"
        >
            <template v-slot:selection="data">
                <v-chip
                        :input-value="data.selected.id"
                        close
                        small
                        color="grey"
                        outlined
                        @click="data.selected"
                        @click:close="remove(data.item.id)"
                >
                    {{ data.item.name }}
                </v-chip>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
    import './regionsMultiple.scss'
    import BaseSimpleAutocomplete from '../../../general/mixins/BaseSimpleAutocomplete';

    export default {
        name: "RegionsMultiple",
        props:['regionId', 'initial', 'withTotalSelect'],
        mixins:[BaseSimpleAutocomplete],
        data() {
            return {
                params: {
                    categoryId: this.categoryId
                },
                searchModels: [],
                selectAllItems: false,
                rules: [value => !!value || this.$t('requiredField')],
            }
        },
        computed: {
            filterName() {
                return this.$store.state.filters.general.region.systemName;
            },
            itemsList() {
                return this.hasExternal ? this.externalItems : this.items;
            },
            hasChips() {
                return !!this.chips;
            },
            componentLabel(){
                return this.label || '';
            },
        },
        methods: {
            selectAll() {
                if(this.selectAllItems) {
                    this.searchModels = this.itemsList;
                } else {
                    this.searchModels = [];
                }

                this.regionsMultiple();
            },
            setServiceState(){
                this.apiService.setRegionsSearch();
            },
            valueChange(){
                let value = [];

                if(this.multiple) {
                    value = this.searchModels.map(item => item.id);
                } else {
                    value = this.searchModel ? [this.searchModel.id] : [];
                }

                const emitData = {
                    name: this.filterName,
                    value: value,
                    key: this.filterKey
                };

                if(this.filterKey && this.filterName) {
                    this.$store.commit('setFilter', emitData);
                    this.setStoreFiltersToUrl();
                }

                this.$emit('value-change', emitData);
            },
            regionsMultiple() {
                this.$emit('regions-multiple', this.searchModels);
            },
            remove(value) {
                this.searchModels = this.searchModels.filter(item => {
                    return item.id !== value;
                });
                this.selectAllItems = false;

                this.valueChange();
                this.$emit('regions-multiple', this.searchModels);
            },
        },
        watch: {
            initial: {
                handler() {
                    if(this.initial) this.searchModels = this.initial;

                    this.$emit('regions-multiple', this.searchModels);
                },
                deep: true
            }
        }

    }
</script>
